import apiFetch from '../apiFetch'

export default function (quota, token) {
  return apiFetch({ endPoint: 'ProcessingAgencyQuota/Delete', method: 'DELETE', body: quota, token: token })
}
